export const typeOfFilterByValueConfirmDialog = 'FilterByValueConfirmDialogType';
export const headerString = 'Close filter by value?';
export const message = 'Closing the filter by value control will remove all entered values. Do you want to continue?';
